import React from 'react';
import { useParams } from 'react-router-dom';
import { Users } from 'lucide-react';
import TeamManagement from '@/components/team/TeamManagement';
import { useProjectMember } from '@/hooks/useProjectMember';
import { useAuth } from '@/hooks/useAuth';

const Team: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { user } = useAuth();
  const { role, hasPermission } = useProjectMember(projectId);

  // Check if current user can manage team
  const isOwnerOrManager = role === 'owner' || role === 'project_manager';
  const isGlobalAdmin = user?.role === 'admin';
  const hasTeamPermissions = hasPermission('manage_team') || hasPermission('invite_members');
  const currentUserCanManage = isOwnerOrManager || isGlobalAdmin || hasTeamPermissions;

  if (!projectId) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Users className="mx-auto h-8 w-8 text-gray-300" />
          <p className="mt-2 text-sm text-gray-500">No project selected</p>
        </div>
      </div>
    );
  }

  return <TeamManagement projectId={projectId} currentUserCanManage={currentUserCanManage} />;
};

export default Team;
